export default __webpack_public_path__ + "static/media/greenCanvas.87c6f5a2.PNG";